import { Component } from 'react';
import { FieldProps } from 'formik';

import t from 'utils/i18n';
import { BraxUncontrolledPhoneField, BraxUncontrolledPhoneFieldProps } from '../../BraxUncontrolledForm';
import { BraxCheckboxField, BraxCheckboxFieldProps } from '../BraxCheckboxField';
import { BraxField } from '../BraxField';

export type BraxPhoneFieldProps = Omit<BraxUncontrolledPhoneFieldProps, 'name' | 'whatsapp'> & {
    name: string,
    whatsapp: boolean | BraxCheckboxFieldProps,
    readOnly: boolean
};

export class BraxPhoneField extends Component<BraxPhoneFieldProps> {

    static defaultProps = {
        readOnly: false,
        whatsapp: true
    };

    change(value: string, formik: FieldProps) {
        formik.form.setFieldValue(this.props.name, value);

        this.props.onChange?.(value);
    }

    render() {
        const { whatsapp, name, hint, disabled, readOnly, onChange, ...props } = this.props;

        return (
            <BraxField name={name} hint={hint} disabled={disabled} readOnly={readOnly}>
                { ({ formik, onChange, ...fieldProps }) => (
                    <BraxUncontrolledPhoneField
                        whatsapp={whatsapp ? () => (
                            <BraxCheckboxField
                                name="isWhatsapp"
                                label={t('É WhatsApp?')}
                                {...(typeof whatsapp === 'object' ? whatsapp : {} as {})}
                            />
                        ) : false}
                        onChange={value => this.change(value, formik)}
                        {...fieldProps}
                        {...props}
                    />
                ) }
            </BraxField>
        );
    }

}
